import React, { useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '809229108816-lecipo295ckfu71qrrqeihfogqq2f35o.apps.googleusercontent.com';

export default function GoogleSignInButton() {
  const { t, i18n } = useTranslation();
  const { googleLogin } = useAuth();
  const navigate = useNavigate();
  const btnRef = useRef(null);

  const handleCredentialResponse = useCallback(async (response) => {
    try {
      await googleLogin(response.credential);
      navigate('/app');
    } catch (err) {
      console.error('Google login error:', err);
    }
  }, [googleLogin, navigate]);

  useEffect(() => {
    const init = () => {
      if (!window.google?.accounts?.id || !btnRef.current) return false;
      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: handleCredentialResponse,
        use_fedcm_for_prompt: false,
      });
      // Render official Google button inside our container
      window.google.accounts.id.renderButton(btnRef.current, {
        type: 'standard',
        shape: 'rectangular',
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        locale: t('shell.googleSignIn.locale'),
        width: btnRef.current.offsetWidth || 320,
      });
      return true;
    };

    if (!init()) {
      const interval = setInterval(() => {
        if (init()) clearInterval(interval);
      }, 200);
      return () => clearInterval(interval);
    }
  }, [handleCredentialResponse, t, i18n.language]);

  return (
    <div className="google-btn-wrap">
      <div ref={btnRef} style={{ width: '100%', minHeight: 44 }} />
    </div>
  );
}
